import Vue from "vue";

Vue.directive("lazyload", {
  bind(el, binding) {
    let lazyLoadObser = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        let lazyImage = entry.target;
        if (entry.intersectionRatio > 0) {
          if (binding.value.imgUrl) {
            lazyImage.src = binding.value.imgUrl;
          }
          if (binding.value.animate) {
            el.classList.add(binding.value.animate);
          }
          lazyLoadObser.unobserve(lazyImage);
        }
      });
    });
    lazyLoadObser.observe(el);
  },
});

// 防重复点击(指令实现)
Vue.directive("preventReClick", {
  inserted(el, binding) {
    el.addEventListener("click", () => {
      if (!el.disabled) {
        el.disabled = true;
        setTimeout(() => {
          el.disabled = false;
        }, binding.value || 1000);
      }
    });
  },
});
